import { createPartyRequest } from './helper';
export const postGetPartiesBasicData = createPartyRequest({
    source: 'data',
    method: 'post',
    route: '/party/parties/basicdata',
});
